export default "__VITE_ASSET__f158637f__"